import React from 'react'
import { ModalBody, ModalFooter } from 'reactstrap'
import { useEeocDocById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const eeoc = useEeocDocById(id)
  const name = eeoc?._candidate?.lastFirstName ?? ''
  const formatedName = name.replaceAll(/[^a-zA-Z ]/g, '').replaceAll(' ', '_')
  const filename = `${formatedName}_EEOC_Documents.pdf`
  const documents = eeoc?.documents ?? undefined
  if (documents === null) {
    return (
      <ModalBody className='vh100'>
        <p>No EEOC documents found</p>
      </ModalBody>
    )
  }
  return (
    <>
      <ModalBody className='vh100'>
        <embed src={documents} style={{ width: '100%', height: '100%' }} title={filename} />
      </ModalBody>
      <ModalFooter>
        <a className='btn btn-primary' href={documents} download={filename}>Download</a>
      </ModalFooter>
    </>
  )
}

export default Body
